import Vue from 'vue';

// Branded fonts
// needed for non-lichen pages like Submit
import '@/base/global-css/fonts/_latin.scss'
import '@/base/global-css/fonts/_overrides.scss'
import '@/base/global-css/fonts/_cyrillic.scss'
import '@/base/global-css/fonts/_hebrew.scss'
import '@/base/global-css/fonts/_jp.scss'
import '@/base/global-css/fonts/_sc.scss'
import '@/base/global-css/fonts/_tc.scss'

// polyfills for IE11
import '@/base/global-js/Polyfills';

// js utilities that need direct access to the DOM
import '@/base/global-js/LanguageSwitcher';
//import '@/base/global-js/TogglePanel';
import '@/base/global-js/Utilities';

// Component dependencies
import EbirdHeaderFooter from './EbirdHeaderFooter.vue';

// base
import CloSkipTo from '@/base/CloSkipTo/CloSkipTo';
Vue.component('CloSkipTo', CloSkipTo);

// navigation
import CloHeader from '@/navigation/CloHeader/CloHeader.vue';
Vue.component('CloHeader', CloHeader);

import CloFooter from '@/navigation/CloFooter/CloFooter.vue';
Vue.component('CloFooter', CloFooter);

// Style tweaks for old pages
import EbirdHeaderFooterTweaks from './EbirdHeaderFooterTweaks.vue';

// component initialization, dialogs, exotic dialog, lazy loading components
import '../shared/sharedLichen.js';